import React from 'react';
import {  withRouter } from 'react-router-dom';
import { userActions } from '../../redux/actions/user-actions';
import { connect } from 'react-redux';
import ChangePassword from './ChangePassword';
class ResetPasswordForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			submitted: false,
			formType: this.props.formTypePro || '',
		};
	}

	render() {
		return (
			<ChangePassword
				recover_account={true}
			/>
		);
	}
}


const mapDispatchToProps = dispatch => {
	return ({
		changePasswordCall: (id, data) => { return dispatch(userActions.changeUserPassword(id, data)) },
	});
};

export default withRouter(connect(null, mapDispatchToProps)(ResetPasswordForm));


// WEBPACK FOOTER //
// ./src/components/Admin/ResetPasswordForm.jsx